import { useState, useEffect, useRef, useCallback } from "react";
import { Star, ThumbsUp, ChevronLeft, ChevronRight, CheckCircle } from "lucide-react";

const RED = "#D41F30";

const REVIEWS = [
  { platform: "google", name: "Nick Potter", quote: "Absolutely amazing experience from start to finish. Being a first time homebuyer, I really didn't know how to get an advantage in such a competitive space. Everyone from our agent to the mortgage coordinator was super available, helpful, and willing to do whatever we could to get the best deal possible. On top of that, the communication was seamless, because the mortgage and the realty is all in one. I've already recommended them to someone else!" },
  { platform: "google", name: "Colin Malo", quote: "Working with Patrick at CityWorth was a pleasure. He and his team made an intimidating home buying process much less daunting through consistent transparency and constant communication. One of the reasons we got into our dream home was due to Patrick's quick response time to the seller. This is a great team to partner with if you are looking to buy a home!" },
  { platform: "google", name: "Mina Akhnoukh", quote: "Patrick, John, Nicoleta, and Co. are dedicated professionals who made my home buying process come to life! When I first started working with Patrick, I was skeptical that I would actually find a property. However, Patrick kept a steadfast belief in the end goal that carried me to a shiny set of keys. I love how they have still maintained contact after closing, they really build those relationships." },
  { platform: "google", name: "David Dias", quote: "This was my first home buying experience so you could imagine I was a nervous wreck. Patrick Shumway reached out to me when I showed interest in a specific house, and in a little over 30 days I became a first time home owner! Special shout to Patrick, Nicoleta, John, and everyone else. They were very friendly and knowledgeable and I would highly recommend their services." },
  { platform: "trustpilot", name: "Nebeyu Engida", quote: "David and his team were amazing. True go-getters and always available whenever you need them. They made buying a house so seamless and worry free. We couldn't imagine where we'd be without them." },
  { platform: "google", name: "Price Wheeler", quote: "We've worked with CityWorth multiple times now, and every experience has been nothing short of excellent. Their customer service is top-notch, responsive, knowledgeable, and always willing to go the extra mile to make the process smooth and stress-free. As repeat customers, we keep coming back because they consistently deliver. They've earned our loyalty and our referrals!" },
  { platform: "trustpilot", name: "Chloe", quote: "I worked with CityWorth and they taught me so much about the homebuying process. As someone that has never owned a home, I had a lot of questions, but they walked me through everything. On top of that, their customer service is truly unmatched, it's the best experience I've ever had with any company. I felt supported every step of the way and couldn't be more grateful!" },
  { platform: "google", name: "David Resto", quote: "AWESOME EXPERIENCE with my home buying experience with CityWorth Mortgage. I am so grateful to David, John, Nicoleta, Matthieu and Caroline. This TEAM IS TOP NOTCH. What took the other experience to do in 4 months only took 60 days with CityWorth. YOU CAN'T GO WRONG WITH CITYWORTH!" },
  { platform: "trustpilot", name: "Nicholas Rebold", quote: "Worked with them through Howard University, great experience for any first-time home buyer and very thorough." },
  { platform: "google", name: "Melissa Perdue", quote: "My mortgage team (Dylan, Patrick, and Nicoletta) were awesome. They helped me with great patience through every step of the process. My family and I thank you from the bottom of our hearts." },
  { platform: "google", name: "Joe Rodriguez", quote: "These guys and gals are the best in the business. I had trouble with other mortgage companies getting the run around. My cousin got me connected and within a month or so I was looking and closing on my first home. These guys went above and beyond and made the process easy to understand." },
  { platform: "google", name: "Tonya Jasmin", quote: "Wonderful experience! This is my second time utilizing CityWorth. Patrick, Chad, Lavina and Matt make the transaction so care free and easy. They are with you every step of the way!" },
  { platform: "trustpilot", name: "Veteran Rider", quote: "It was a very rough time gathering all needed to get this home to close. But it was made possible with the guys at CityWorth. I love the energy and commitment they provided me to accomplish this dream." },
  { platform: "google", name: "Hamidullah Wardak", quote: "Working with CityWorth and David Shumway to buy my home was an absolute game-changer! David's professionalism is unmatched, and his knowledge of the market is second to none. What truly sets him apart is his unwavering commitment to his clients, he was always available, no matter the time. He made the entire process seamless and stress-free." },
  { platform: "google", name: "Gail Chagnon", quote: "I was in the hospital for most of this process and they were very accommodating. The whole process of locating a house and getting to a contract could not be beat." },
  { platform: "google", name: "Courtney Lemons", quote: "Jessica Boone is the best of the best!! Call her for your buying and selling needs!! She communicates well and often. She knows her stuff and makes sure you are taken care of all the way around! We have used CityWorth for 3 purchases and they are always on point!! Highly recommend!!" },
  { platform: "google", name: "Mary Dixon", quote: "I had the pleasure of working with Patrick, John Henry, Nicoleta, Mathieu and Caroline. These are some of the most amazing people! Patrick literally became our best friend! This was mine and my boyfriend's first purchase so we knew absolutely nothing about the process but they held our hand through it all." },
  { platform: "trustpilot", name: "Jem Q", quote: "I highly recommend David Shumway! His team has been a great help since we started with our home search. As first-time home buyers, David explained every step in the process. He always sends messages and called us about any update. The home buying process went on smoothly. He is like a family member now. Don't hesitate to reach out to him." },
  { platform: "google", name: "Hosein Alizadeh", quote: "I'd have never got the lovely home that I purchased recently without CityWorth Homes's support. The team is highly dynamic which is required these days to purchase a house. I got spontaneous response from the first call and it continued through the whole process. Special thanks to entire team which spared their time to our schedule." },
  { platform: "google", name: "Mohammad Amiri", quote: "I would like to commend David Shumway and his team, including Chad Grimm, Matt Wetmore, Caroline Kim, and Lavinia Popescu, for their exceptional dedication and promptness in executing tasks efficiently. Mr. Shumway is profoundly passionate about assisting individuals in achieving their American Dream." },
  { platform: "google", name: "Ronald Kirby", quote: "Hands down the best staff and work promptly in not only getting the job done quickly, they are really for their clients. David and John are so caring about their passion in helping people achieve their American Dream that they work diligently in delivering everything promised to you. I guarantee you not only will they answer but give you the best service you can possibly imagine." },
  { platform: "google", name: "Wesley Beeler", quote: "I've bought two homes with this company. They are amazing and work their butts off to help. David and Chad were very helpful and I couldn't imagine going with another company. I absolutely recommend them." },
];

const PlatformBadge = ({ platform }) => {
  if (platform === "trustpilot") {
    return (
      <div className="inline-flex items-center gap-2">
        <div
          className="w-7 h-7 rounded-md flex items-center justify-center text-white text-xs font-black flex-shrink-0"
          style={{ background: "#00B67A" }}
          aria-label="Trustpilot"
        >
          T
        </div>
        <span className="text-xs font-semibold text-gray-500">Trustpilot</span>
      </div>
    );
  }
  return (
    <div className="inline-flex items-center gap-2">
      <div
        className="w-7 h-7 rounded-md flex items-center justify-center text-white text-xs font-black flex-shrink-0"
        style={{ background: "linear-gradient(135deg,#a855f7 0%,#ec4899 100%)" }}
        aria-label="Google"
      >
        G
      </div>
      <span className="text-xs font-semibold text-gray-500">Google</span>
    </div>
  );
};

const ReviewCard = ({ r }) => (
  <div className="bg-white rounded-3xl p-8 shadow-sm border border-gray-100 h-full flex flex-col">
    <div className="flex items-center justify-between mb-5">
      <div className="flex gap-1">
        {[...Array(5)].map((_, i) => (
          <Star key={i} className="w-4 h-4 text-yellow-400 fill-yellow-400" />
        ))}
      </div>
      <PlatformBadge platform={r.platform} />
    </div>
    <p className="text-gray-700 leading-relaxed mb-6 flex-1 text-sm md:text-base">
      &ldquo;{r.quote}&rdquo;
    </p>
    <div className="flex items-center gap-2 pt-4 border-t border-gray-100">
      <CheckCircle className="w-5 h-5 text-green-500 flex-shrink-0" />
      <p className="font-semibold text-gray-900 text-sm">{r.name}</p>
    </div>
  </div>
);

export default function ReviewsSection({ testId = "reviews" }) {
  const trackRef = useRef(null);
  const [perView, setPerView] = useState(3);
  const [page, setPage] = useState(0);

  useEffect(() => {
    const update = () => {
      if (window.innerWidth < 640) setPerView(1);
      else if (window.innerWidth < 1024) setPerView(2);
      else setPerView(3);
    };
    update();
    window.addEventListener("resize", update);
    return () => window.removeEventListener("resize", update);
  }, []);

  const totalPages = Math.max(1, Math.ceil(REVIEWS.length / perView));

  const scrollToPage = useCallback(
    (p) => {
      const idx = Math.max(0, Math.min(totalPages - 1, p));
      setPage(idx);
      const track = trackRef.current;
      if (track) {
        track.scrollTo({ left: idx * track.clientWidth, behavior: "smooth" });
      }
    },
    [totalPages]
  );

  useEffect(() => {
    // When viewport changes, clamp page to valid range
    setPage((current) => (current > totalPages - 1 ? 0 : current));
  }, [totalPages]);

  const onScroll = () => {
    const track = trackRef.current;
    if (!track) return;
    const p = Math.round(track.scrollLeft / track.clientWidth);
    setPage((current) => (p !== current ? p : current));
  };

  return (
    <section
      className="py-20 md:py-28 bg-gradient-to-br from-amber-50/40 via-white to-orange-50/30 relative overflow-hidden"
      data-testid={testId}
    >
      <div className="relative max-w-6xl mx-auto px-6 md:px-12">
        <div className="text-center">
          <div className="inline-flex items-center gap-2 bg-white border border-gray-200 rounded-full px-4 py-2 mb-10 shadow-sm">
            <ThumbsUp className="w-4 h-4" style={{ color: RED }} />
            <span className="text-xs font-bold tracking-[0.18em] text-gray-700 uppercase">
              Customer Reviews
            </span>
          </div>

          <h2 className="font-display text-5xl md:text-6xl lg:text-7xl font-black text-gray-900 leading-[1.05] tracking-tight mb-8">
            <span
              className="bg-gradient-to-r from-[#D41F30] via-fuchsia-500 to-indigo-600 bg-clip-text text-transparent"
              style={{ WebkitBackgroundClip: "text", backgroundClip: "text" }}
            >
              1,000+
            </span>{" "}
            5-Star Reviews
          </h2>

          <div className="flex justify-center gap-1.5 mb-6">
            {[...Array(5)].map((_, i) => (
              <Star key={i} className="w-7 h-7 text-yellow-400 fill-yellow-400" />
            ))}
          </div>

          <p className="text-base md:text-lg text-gray-600 max-w-xl mx-auto mb-14 leading-relaxed">
            Real people. Real homes. Real results. See why thousands of homebuyers trust CityWorth.
          </p>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 max-w-3xl mx-auto mb-16">
            <div className="bg-white rounded-2xl border border-gray-100 shadow-sm hover:shadow-md transition-shadow p-6 flex items-center gap-5 text-left">
              <div
                className="w-16 h-16 rounded-2xl flex items-center justify-center flex-shrink-0 text-white text-2xl font-black"
                style={{ background: "linear-gradient(135deg,#a855f7 0%,#ec4899 100%)" }}
              >
                G
              </div>
              <div className="flex-1">
                <p className="text-xs font-bold text-gray-400 tracking-widest uppercase mb-1.5">
                  Google Reviews
                </p>
                <div className="flex items-center gap-2 mb-1">
                  <span className="text-2xl font-black text-gray-900 leading-none">4.8</span>
                  <div className="flex gap-0.5">
                    {[...Array(5)].map((_, i) => (
                      <Star key={i} className="w-3.5 h-3.5 text-yellow-400 fill-yellow-400" />
                    ))}
                  </div>
                </div>
                <p className="text-xs text-gray-500">Verified Google Reviews</p>
              </div>
            </div>

            <div className="bg-white rounded-2xl border border-gray-100 shadow-sm hover:shadow-md transition-shadow p-6 flex items-center gap-5 text-left">
              <div
                className="w-16 h-16 rounded-2xl flex items-center justify-center flex-shrink-0 text-white text-2xl font-black"
                style={{ background: "#00B67A" }}
              >
                T
              </div>
              <div className="flex-1">
                <p className="text-xs font-bold text-gray-400 tracking-widest uppercase mb-1.5">
                  Trustpilot
                </p>
                <div className="flex items-center gap-2 mb-1">
                  <span className="text-2xl font-black text-gray-900 leading-none">4.7</span>
                  <div className="flex gap-0.5">
                    {[...Array(5)].map((_, i) => (
                      <Star key={i} className="w-3.5 h-3.5 text-yellow-400 fill-yellow-400" />
                    ))}
                  </div>
                </div>
                <p className="text-xs text-gray-500">Verified Trustpilot Reviews</p>
              </div>
            </div>
          </div>
        </div>

        {/* Reviews carousel */}
        <div className="relative">
          <div
            ref={trackRef}
            onScroll={onScroll}
            className="flex overflow-x-auto snap-x snap-mandatory scroll-smooth gap-6 pb-2"
            style={{ scrollbarWidth: "none", msOverflowStyle: "none" }}
          >
            {Array.from({ length: totalPages }).map((_, pageIdx) => (
              <div
                key={pageIdx}
                className="flex gap-6 flex-shrink-0 snap-start"
                style={{ width: "100%" }}
              >
                {REVIEWS.slice(pageIdx * perView, pageIdx * perView + perView).map((r, i) => (
                  <div
                    key={i}
                    className="flex-shrink-0"
                    style={{ width: `calc((100% - ${(perView - 1) * 24}px) / ${perView})` }}
                  >
                    <ReviewCard r={r} />
                  </div>
                ))}
              </div>
            ))}
          </div>

          {/* Hide scrollbar (chrome/safari) via inline style isn't possible; use parent class trick */}
          <style>{`
            section[data-testid="${testId}"] .flex.overflow-x-auto::-webkit-scrollbar { display: none; }
          `}</style>

          {/* Controls */}
          <div className="flex items-center justify-center gap-4 mt-8">
            <button
              type="button"
              onClick={() => scrollToPage(page - 1)}
              disabled={page === 0}
              aria-label="Previous reviews"
              className="w-11 h-11 rounded-full border-2 border-gray-200 bg-white text-gray-700 hover:border-[#D41F30] hover:text-[#D41F30] disabled:opacity-40 disabled:cursor-not-allowed flex items-center justify-center transition-colors"
              data-testid="reviews-prev"
            >
              <ChevronLeft className="w-5 h-5" />
            </button>

            <div className="flex items-center gap-2">
              {Array.from({ length: totalPages }).map((_, i) => (
                <button
                  key={i}
                  type="button"
                  onClick={() => scrollToPage(i)}
                  aria-label={`Go to page ${i + 1}`}
                  className={`h-2 rounded-full transition-all duration-300 ${
                    i === page ? "w-8 bg-[#D41F30]" : "w-2 bg-gray-300 hover:bg-gray-400"
                  }`}
                  data-testid={`reviews-dot-${i}`}
                />
              ))}
            </div>

            <button
              type="button"
              onClick={() => scrollToPage(page + 1)}
              disabled={page === totalPages - 1}
              aria-label="Next reviews"
              className="w-11 h-11 rounded-full border-2 border-gray-200 bg-white text-gray-700 hover:border-[#D41F30] hover:text-[#D41F30] disabled:opacity-40 disabled:cursor-not-allowed flex items-center justify-center transition-colors"
              data-testid="reviews-next"
            >
              <ChevronRight className="w-5 h-5" />
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
